import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';


@Injectable()
export class DenyStaffService implements CanActivate  {

  private _lastCheck: number;

  private _sendToTablet(): Observable<boolean> {
    this._router.navigateByUrl('/tablet');
    return Observable.of(false);
  }

  constructor(private _router: Router, private _auth: AuthService) { }

  canActivate(): Observable<boolean> {

    let user = this._auth.getUser();
    if(user.role == "Staff") {
      this._router.navigateByUrl('/tablet');
      return Observable.of(false);
    }
    return Observable.of(true);


  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/deny-staff.service.ts